import './03-page.sass'

export { default } from './03-page.js'
